<script lang="ts" setup>
import { CollapseContent, ButtonComp, UserComp, MenuSmall, MenuNormal } from '@/components';
import { onMounted, onUnmounted, ref } from 'vue';
import { menu } from '@/.';

const props = defineProps<{
    showOnlyOn: 'BIG' | 'SMALL';
}>();

const small = ref<boolean>(false);

const handleResize = () => {
    if (window.innerWidth < 768) small.value = true;
};

onMounted(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

// is the component hidden
const isHidden = ref<boolean>(false);
</script>
<template>
    <!-- 
        For small screens ( everything below 768px wide. ) we render a small menu, with an access button
        in the top right corner. This button will open the offcanvas menu when clicked.
        inside the offcanvas menu we use the MenuNormal component to render the menu.
    -->
    <div
        class="d-block d-md-none"
        v-if="small && showOnlyOn === 'SMALL'"
    >
        <MenuSmall :menu="menu" />
    </div>

    <!-- 
        This is the menu for BIG screens ( everything above 768px wide. )
        This one is rendered as a sidebar menu on the left side of the screen.
        And can collapse to a small menu with only the icons.
    -->
    <CollapseContent
        :visible="!isHidden"
        :horizontal="true"
        :usecustomTransition="true"
        v-if="!small && showOnlyOn === 'BIG'"
        id="normalmenu"
        class="shadow-sm menu-left flex-column d-none d-md-flex mainmenu border-end"
    >
        <MenuNormal :menu="menu" />

        <div class="container menu-user text-nowrap">
            <div class="d-flex flex-nowrap align-items-center justify-content-between border-top border-dark-subtle py-3">
                <ButtonComp
                    button-type="Custom"
                    :icon="!isHidden ? 'fa-left-to-line' : 'fa-right-from-line'"
                    class="shadow-none no-focus"
                    @click="isHidden = !isHidden"
                />
                <UserComp />
            </div>
        </div>
    </CollapseContent>
</template>
